export default {"src":"/_next/static/media/village.5350ca5b.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};